import React, { useEffect, useState } from 'react'
import AddLayout from '../../../../component/AddLayout'
import { Autocomplete, Box, Button, FormControl, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import dayjs from 'dayjs'
import DatePicker from '../../../../component/DatePicker'
import { addRawSeed, getItemMasterList, getItemRawBalanceList, getMaterialsList, getMaterialsRawList, getZones } from '../../services/api'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { GetBreedClassNo, GetSeasonNo } from '../../../stock/services/stockService'
import ConfirmDialog from '../component/ConfirmDialog'

export default function PaidForFactoryAdd() {
  const { profile, loading } = useSelector(state => state.profile)
  const location = useLocation()
  const navigate = useNavigate();
  const [refNoError, setRefNoError] = useState(false)
  const [senderOrReceiver, setSenderOrReceiver] = useState('กลุ่มผลิตเมล็ดพันธุ์ (งานโรงงาน)')
  const [source, setSource] = useState('')
  const [documentDate, setDocumentDate] = useState(dayjs(new Date()))
  const [items, setItems] = useState([])
  const [filterItem, setFilterItems] = useState([])
  const [materials, setMaterials] = useState([])
  const [branchs, setBranchs] = useState([])
  const [name, setName] = useState('')
  const [open, setOpen] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [documentType, setDocumentType] = useState('จ่าย');
  const [seedType, setSeedType] = useState('ซื้อคืน');
  const [rows, setRows] = useState([
    {
      RefNo: "",
      ItemNo: null,
      Year: null,
      Lot: null,
      MaterialNo: "",
      MaterialQty: 0,
      Qty: 0,
      WarehouseNo: "",
      ZoneNo: "",
      Remark: ""
    }
  ]);
  function addRow() {
    const newRow = {
      RefNo: "",
      ItemNo: null,
      Year: null,
      Lot: "",
      MaterialNo: "",
      MaterialQty: 0,
      Qty: 0,
      WarehouseNo: "",
      ZoneNo: "",
      Remark: ""
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e, index) => i !== index);
    setRows(data);
  };
  useEffect(() => {
    if (location.state) {
      setRows([
        {
          RefNo: "",
          ItemNo: location.state.ItemNo,
          Year: location.state.Year,
          Lot: { Lot: location.state.Lot },
          MaterialNo: "",
          MaterialQty: 0,
          Qty: 0,
          WarehouseNo: location.state.WarehouseNo.WarehouseNo,
          ZoneNo: location.state.ZoneNo.ZoneNo,
          Remark: ""
        }
      ])
    }
  }, [location.state])

  useEffect(() => {
    const getZonesList = async () => {
      const data = await getZones(profile?.BranchNo?.BranchNo)
      setBranchs(data)
    }
    getZonesList()
  }, [profile])

  useEffect(() => {

    const getItemRawBalance = async () => {
      const data = await getItemRawBalanceList(profile?.BranchNo?.BranchNo, seedType)
      setItems(data)
    }

    getItemRawBalance()



  }, [documentType, profile])
  useEffect(() => {
    const getMaterials = async () => {
      const data = await getMaterialsRawList()
      setMaterials(data)
    }
    getMaterials()
  }, [])
  const handleSubmit = (e) => {

    if (rows?.filter((x) => !x?.ItemNo)) {
      const item = rows?.map((v, index) => {
        v.LotError = v.ItemNo ? false : true
        return v;

      });
      setRows([...item]);
    }

    if (rows?.filter((x) => x?.Year?.length < 1)) {
      const item = rows?.map((v, index) => {
        v.YearError = v?.Year?.length >= 1 ? false : true
        return v;

      });
      setRows([...item]);
    }

    if (rows?.filter((x) => !x?.Lot)) {
      const item = rows?.map((v, index) => {
        v.LotgenError = v.Lot ? false : true
        return v;

      });
      setRows([...item]);
    }
    if (rows?.filter((x) => x?.WarehouseNo?.length < 1)) {
      const item = rows?.map((v, index) => {
        v.WarehouseError = v.WarehouseNo ? false : true
        return v;

      });
      setRows([...item]);
    }
    if (rows?.filter((x) => !x?.ItemNo).length === 0 && rows?.filter((x) => x?.Year?.length < 1).length === 0 && rows?.filter((x) => x?.Lot?.length < 3).length === 0 && rows?.filter((x) => x?.WarehouseNo?.length < 1).length === 0) {
      setOpen(true)
    }
  }
  const handleAdd = () => {
    setLoadingSubmit(true)

    const body = {
      DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
      DocumentType: documentType,
      BranchNo: profile?.BranchNo?.BranchNo,
      SenderOrReceiver: senderOrReceiver,
      Source: source,
      SeedCategory: seedType,
      Status: "Y",
      Details: rows?.map((x) => (
        {

          RefNo: x?.RefNo,
          ItemNo: x?.ItemNo?.ItemNo,
          Year: x?.Year,
          Lot: x?.Lot?.Lot,
          MaterialNo: x?.MaterialNo,
          MaterialQty: +x?.MaterialQty.toString().replaceAll(',', ''),
          Qty: +x?.Qty.toString().replaceAll(',', ''),
          WarehouseNo: x?.WarehouseNo,
          ZoneNo: x?.ZoneNo,
          Remark: x?.Remark
        }
      ))
    }
    const post = async () => {
      const res = await addRawSeed(body)
      if (res) {
        setLoadingSubmit(false)
        setOpen(false)
        navigate('/raw/paidforfactory/' + res.DocumentNo, { state: { new: true } })
      }
    }
    post()
    // console.log(body);
  }
  const getLastLot = async (prefix) => {

    let _params = '';

    if (prefix) {
      _params = '?prefix=' + prefix;
    }
    // await getData(STOCK_CONFIG.requests.getLastLot.url + _params).then((response) => {
    //     if (response.status === true) {
    //         setLastLot(response.result)
    //     }
    // })
  }
  const inputHead = [
    {
      name: 'วันที่ทำรายการ',
      inputComponent: <><DatePicker value={documentDate} onChange={e => setDocumentDate(e)} disabled={false} /></>,
    },
    {
      name: '',
      inputComponent: <></>,
    },
    {
      name: 'จ่ายให้',
      inputComponent: <>
        <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
          <TextField value={senderOrReceiver}
            // onBlur={e => {
            //     if (!e.target.value) {
            //         setRefNoError(true)
            //     } else {
            //         setRefNoError(false)
            //     }
            // }} 
            onChange={e => setSenderOrReceiver(e.target.value)} variant="standard" fullWidth
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />
        </Box>
        {/* <RequireField value={senderOrReceiver} onChange={setSenderOrReceiver} type={'text'} disabled={false} error={refNoError} setError={setRefNoError} textError={'กรุณาที่รับ'} /> */}
      </>,
    },
    {
      name: 'ชื่อโรงงาน',
      inputComponent: <>
        <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
          <TextField value={source}
            // onBlur={e => {
            //     if (!e.target.value) {
            //         setRefNoError(true)
            //     } else {
            //         setRefNoError(false)
            //     }
            // }} 
            placeholder='โรงงาน A'
            onChange={e => setSource(e.target.value)} variant="standard" fullWidth
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>
        {/* <RequireField value={senderOrReceiver} onChange={setSenderOrReceiver} type={'text'} disabled={false} error={refNoError} setError={setRefNoError} textError={'กรุณาที่รับ'} /> */}
      </>,
    },


  ]

  function removeDuplicates() {

    // Create an array of objects
    const books = items.map((x) => { return { ...x?.ItemNo, ZoneNo: x?.ZoneNo } })

    const jsonObject = books.map(JSON.stringify);
    const uniqueSet = new Set(jsonObject);
    const uniqueArray = Array.from(uniqueSet).map(JSON.parse);

    // Display the unique objects
    return uniqueArray;
  }

  const head = [
    'เลขที่อ้างอิง',
    'เมล็ดพันธุ์',
    'ชั้นพันธุ์',
    'ฤดู',
    'ปีที่ผลิต',
    'ล็อตที่',
    'ประเภทบรรจุภัณฑ์',
    'จำนวน (กระสอบ)',
    'ปริมาณ (กิโลกรัม)',
    'ปริมาณเฉลี่ย/กระสอบ',
    'โรงเก็บที่',
    'หมายเหตุ',
    ''
  ]
  const body = rows?.map((x, i) => {


    return {
      item1: <TextField value={x?.RefNo || ''}
        sx={{ background: '#fff', width: '150px' }}
        size='small' fullWidth variant='outlined'
        onChange={e => {
          const item = rows?.map((v, index) => {
            v.RefNo = index === i ? e.target.value : v?.RefNo;
            return v;

          });
          setRows(item);
        }}
      />,
      item2: <>
        <Autocomplete
          size='small'
          options={removeDuplicates()}
          getOptionLabel={(option) => option?.ItemName}
          onBlur={e => {
            const item = rows?.map((v, index) => {
              v.LotError = index === i ? x.ItemNo ? false : true : v?.LotError;
              return v;
            });
            setRows([...item]);
          }
          }
          componentsProps={{
            paper: {
              sx: {
                width: 500
              }
            }
          }}
          renderOption={(props, option) => (
            <Box component="li" {...props} key={option.ItemNo}>
              {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1} 
            </Box>
          )}
          value={x?.ItemNo}
          onChange={(event, newValue) => {
            const item = rows?.map((v, index) => {
              v.LotGen = index === i ? null : v?.LotGen;
              v.ItemNo = index === i ? newValue : v?.ItemNo;
              v.Year = index === i ? newValue?.Year : v?.Year;
              v.Lot = index === i ? newValue?.Lot : v?.Lot;
              v.ZoneNo = i === index ? newValue?.ZoneNo?.ZoneNo : v?.ZoneNo

              return v;

            });
            setRows([...item]);

          }}

          renderInput={(params) => (
            <Box ref={params.InputProps.ref}>
              <OutlinedInput error={!x?.LotError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: '#fff' }} />
            </Box>
          )}
        />
        {!x?.LotError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: "10px" }}>กรุณาเลือกเมล็ดพันธุ์</span>}</>,
      item3: x?.ItemNo?.Option2,
      item4: <span style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}</span>,
      item5: <> <TextField className='w-70' value={x?.Year}
        size='small' variant='outlined'
        sx={{ background: '#e9ecef' }}
        inputProps={{ maxLength: 2 }}
        disabled
      />
      </>,
      item6: <> <Autocomplete
        size='small'
        options={items?.filter((y) => y?.ItemNo?.ItemNo === x?.ItemNo?.ItemNo)}
        getOptionLabel={(option) => option?.Lot}
        onBlur={e => {
          const item = rows?.map((v, index) => {
            v.LotgenError = index === i ? x?.Lot ? false : true : v?.LotgenError;
            return v;
          });
          setRows([...item]);
        }
        }
        componentsProps={{
          paper: {
            sx: {
              width: 500
            }
          }
        }}
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.ItemNo}>
            {option?.Lot}
          </Box>
        )}
        value={x?.Lot}
        onChange={(event, newValue) => {
          const item = rows?.map((v, index) => {
            v.Year = index === i ? newValue?.Year : v?.Year;
            v.Lot = index === i ? newValue : v?.Lot;
            return v;

          });
          setRows([...item]);

        }}

        renderInput={(params) => (
          <Box ref={params.InputProps.ref}>
            <OutlinedInput error={!x?.LotError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: '#fff' }} />
          </Box>
        )}
      />      {!x?.LotgenError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: '10px' }}>กรุณาระบุล็อต</span>}</>,

      item7: <FormControl className='w-120' variant="outlined" size='small' fullWidth
        error={x?.MaterialNoError}
      >
        <Select value={x?.MaterialNo} onChange={e => {
          const item = rows?.map((v, index) => {
            v.MaterialNo = i === index ? e.target.value : v?.MaterialNo;
            v.MaterialName = i === index ? materials?.find((x) => x?.ItemNo === e.target.value)?.ItemName : v?.MaterialName

            return v;

          });
          setRows([...item]);
        }} onBlur={e => {
          const item = rows?.map((v, index) => {
            v.MaterialNoError = index === i ? x.MaterialNo ? false : true : v?.MaterialNoError;
            return v;

          });
          setRows([...item]);
        }}
          MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
        >
          {materials?.map((z, i) => {
            return (
              <MenuItem key={i} value={z?.ItemNo}>{z?.ItemName}</MenuItem>
            )
          })}
        </Select>
      </FormControl>,
      item8: <TextField value={x?.MaterialQty.toLocaleString()}
        sx={{ background: '#fff', width: '120px' }}
        type='tel' size='small' fullWidth variant='outlined' onChange={e => {
          let newValue = e.target.value.replace(/,/g, "");

          let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          const item = rows?.map((v, index) => {
            v.MaterialQty = i === index ? abc : v?.MaterialQty;
            v.OtyPer = i === index ? +x?.Qty?.toString().replaceAll(',', '') / +e.target.value.toString().replaceAll(',', '') : v?.OtyPer
            return v;

          });
          setRows([...item]);
        }} onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }} />,
      item9: <TextField value={x?.Qty.toLocaleString()}
        sx={{ background: '#fff', width: '120px' }}
        type='tel' size='small' fullWidth variant='outlined' onChange={e => {

          let newValue = e.target.value.replace(/,/g, "");

          let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          const item = rows?.map((v, index) => {
            v.OtyPer = i === index ? x?.Lot?.Balance < +newValue ? x?.Lot?.Balance / +x?.MaterialQty.toString().replaceAll(',', '') : +e.target.value.toString().replaceAll(',', '') / +x?.MaterialQty.toString().replaceAll(',', '') : v?.OtyPer
            v.Qty = i === index ? x?.Lot?.Balance < +newValue ? x?.Lot?.Balance : abc : v?.Qty;
            return v;

          });
          setRows([...item]);
        }} onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }} />,
      item10: x?.OtyPer?.toLocaleString(),
      item11: <> <FormControl className='w-120' variant="outlined" size='small' fullWidth
        error={x?.WarehouseError}
      >
        <Select value={x?.ZoneNo} onChange={e => {
          const item = rows?.map((v, index) => {
            v.WarehouseNo = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value)?.WarehouseNo.WarehouseNo : v?.WarehouseNo;
            v.ZoneNo = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value).ZoneNo : v?.ZoneNo
            v.WarehouseName = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value)?.WarehouseNo.WarehouseName : v?.WarehouseName
            v.ZoneName = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value).ZoneName : v?.ZoneName
            return v;

          });
          setRows([...item]);
        }} onBlur={e => {
          const item = rows?.map((v, index) => {
            v.WarehouseError = index === i ? x.WarehouseNo ? false : true : v?.WarehouseError;
            return v;

          });
          setRows([...item]);
        }} >
          {/* <MenuItem value='all' disabled>เลือกโรงเก็บ</MenuItem> */}
          {branchs?.map((z, i) => (
            <MenuItem value={z?.ZoneNo}>{z?.WarehouseNo?.WarehouseName} {z?.ZoneName}</MenuItem>
          ))}
        </Select>
      </FormControl>
        {!x?.WarehouseError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-6px', left: "8px" }}>กรุณาเลือกโรงเก็บ</span>}
      </>,
      item12: <TextField sx={{ width: '150px' }} value={x?.Remark} size='small' fullWidth variant='outlined' onChange={e => {

        const item = rows?.map((v, index) => {
          v.Remark = i === index ? e.target.value : v?.Remark;
          return v;

        });
        setRows([...item]);
      }}
      />,
      item13: <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />,
    }
  })
  return (
    <AddLayout
      title={'เพิ่มรายการจ่ายเพื่อปรับปรุง'}
      inputHead={inputHead}
      inputRemark={null}
      bodyTitle={'รายการจ่ายเพื่อปรับปรุง'}
      bodyAction={<FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />}
      tableHead={head}
      tableBody={body}
      bootomAction={<>
        <Button onClick={() => navigate(-1)} variant='outlined'
          startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
          sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
        <Button variant='contained' onClick={() => handleSubmit()} sx={{ width: '130px', fontSize: '14px' }}>บันทึก</Button></>}
      dialog={<ConfirmDialog open={open} setOpen={setOpen} rows={rows} handleSubmit={handleAdd} loadingSubmit={loadingSubmit} />} />
  )
}
